import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Row, Col } from "react-bootstrap";

import { Api } from "../../../utils/Variables";
import { ServiceUrl } from "../../../utils/ServiceUrl";

const LehangaMenu = ({ location, history }) => {
  const [sareeCategory, setSareeCategory] = useState(null);
  const [showMenu, setShowMenu] = useState(true);

  useEffect(() => {
    axios.get(`${Api.Url}${ServiceUrl.MENU.MEGA_MENU}`).then((res) => {
      if (res.data.status === "1") {
        const found = res.data.data.find(
          (item) => item.categoryname.toLowerCase() === "lehenga"
        );
        setSareeCategory(found);
      }
    });
  }, []);

  useEffect(() => {
    setShowMenu(true);
  }, [location.pathname]);

  const handleLinkClick = (slug) => {
    setShowMenu(false);
    const targetPath = `/category/${slug}`;
    if (location.pathname === targetPath) {
      history.replace("/");
      setTimeout(() => {
        history.push(targetPath);
      }, 0);
    } else {
      history.push(targetPath);
    }
  };

  const renderSubCategories = () => {
    if (!sareeCategory || !sareeCategory.subcategory) return null;

    return sareeCategory.subcategory.slice(0, 10).map((item, i) => (
      <a
        key={i}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleLinkClick(item.slug);
        }}
        className="list-group-item list-group-item-action text-muted"
      >
        {item.categoryname}
      </a>
    ));
  };

  return showMenu && sareeCategory ? (
    <div
      className="dropdown-menu"
      style={{ width: "250px", left: "-80px", backgroundColor: "#fff" }}
    >
      <Row>
        <Col>
          <div className="list-group list-group-flush list-group-no-border list-group-sm">
            <div className="subcategories text-white">
              {renderSubCategories()}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  ) : null;
};
export default withRouter(LehangaMenu);
